
import { useNavigate } from 'react-router-dom';

import '../styles/EmployeeMaster.css';
import GradeTable from '../components/GradeTable';

const Grade = () => {
     const navigate = useNavigate();

     const handleAddClick = () => {

          navigate('/grade/add');
     };



     return (
          <div className="employee-master-page">
               <div className="employee-header">
                    <h2>Grade Master</h2>
                    <button className="add-employee-btn" onClick={handleAddClick}>
                         Add Grade
                    </button>
               </div>

               <GradeTable />
          </div>
     );
};

export default Grade;